export default __webpack_public_path__ + "46a005c95d59eefda2243059c02b5342.png";